<lex-case-analytics-item style="--height: 100%;">
    <div card-header-content-primary *ngIf="!shouldShowLoader && !statusView" [@appear]>
        <div>Responsiveness</div>
        <div>Case document <b>review status</b></div>
    </div>
    <div card-header-content-primary *ngIf="!shouldShowLoader && statusView" [@appear]>
        <div>{{statusView.dbSet}}</div>
        <div><b>{{statusView.statusCount | number}} ({{statusView.statusPercentage | number:'1.0-2'}}%)</b></div>  <!-- needed for template  -->
        <div>Documents marked <b>{{statusView.status}}</b></div>
    </div>

    <div card-body-content-chart *ngIf="doughnutChartData.datasets.length > 0" [ngClass]="{'loading': shouldShowLoader === true}">
        <canvas baseChart [data]="doughnutChartData" [options]="doughnutChartOptions" [plugins]="ngChartPlugins" [type]="doughnutChartType"
            aria-label="Doughnut chart showing the status of documents reviewed." role="img">
        </canvas>
    </div>
  <div card-body-content-chart *ngIf="shouldShowLoader" style="display: flex; align-items: center; justify-content: center;">
    <i card-body-loading-icon class="fa-light fa-chart-waterfall fa-fade" style="font-size: 19.2vh;"></i>
  </div>
</lex-case-analytics-item>
